// Module
var code = "<template>\n  <div class=\"no-data-container\">\n    <div class=\"no-data-message\">\n      <b if.bind=\"title\">${title}</b>\n      <span if.bind=\"message\">${message}</span>\n    </div>\n  </div>\n</template>\n";
// Exports
export default code;